import React, { Fragment } from 'react'

import Login from '../views/Login/'
import Activate from '../views/Activate/'
import Forgotten from '../views/Forgotten/'
import Reset from '../views/Reset/'
import ProActive from '../views/ProActive/'
import Axxerion from '../views/Axxerion/'
import AFAS from '../views/AFAS/'
import { Redirect, Switch, Route } from 'react-router-dom'

const UnAuthenticated = ({ login }) => {
  return (
    <Fragment>
      <Switch>
        <Route exact path="/login" render={props => <Login {...props} />} />
        <Route path="/activeren/:id" render={props => <Activate {...props} />} />
        <Route path="/wachtwoord-vergeten/" render={props => <Forgotten {...props} />} />
        <Route path="/wachtwoord-resetten/:token" render={props => <Reset {...props} />} />
        <Route path="/proactive-login/" render={props => <ProActive {...props} />} />
        <Route path="/axxerion-login/" render={props => <Axxerion {...props} />} />
        <Route path="/afas-login/" render={props => <AFAS {...props} />} />
        <Route
          render={props => {
            if (!props.location.pathname.includes('/activeren/') && !props.location.pathname.includes('/wachtwoord')) {
              return <Redirect to="/login" />
            } else {
              return <Redirect to={props.location.pathname} />
            }
          }}
        />
      </Switch>
    </Fragment>
  )
}

export default UnAuthenticated



// WEBPACK FOOTER //
// ./src/App/UnAuthenticated.js